/* eslint-disable @typescript-eslint/no-unsafe-return */
import { DonationField } from '../constants';
import { FormErrors } from '../types';

export const getError = (field: DonationField, errors: FormErrors): string => {
  if (!errors[<any>field]?.message) return '';

  return `x ${errors[<any>field]?.message}`;
};
